import React, { Component } from 'react';

class ContactContainer extends Component {
  render() {
    return (
        <section id="section-contact">
        <div className="container">
            <div className="jumbotron">
                <h1>Contact Me</h1>
                <p>
                    Do you have an interesting project that matches my skill set? Let's talk!
                </p>
                <p>
                    <a href="mailto:amin76taghikhani@gmail.com">amin76taghikhani@gmail.com</a>
                </p>
            </div>
        </div>
    </section>
    );
  }
}

export default ContactContainer;



// WEBPACK FOOTER //
// ./src/containers/contact.container.jsx